import { initializeLogger } from '@seamless/logger';

export const logger = initializeLogger('aem-vuex-module');
